// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3ktBo","noInteraction":"EventWrapper_noInteraction__2MMI4"};